import Request from '@/api/request';
import { CommonObject } from '@/utils/types';
import { AddStatementDraftResp } from '@/api/additionalStatement';

export interface PayloadRecendSave {
  statementId: string;
  reasonSend: string;
}

export interface PayloadRecendSendPackage {
  addStatementId: string;
  xmlSigBase64: string;
}

const api = new Request('lk/recend/statement/');

export function recendGetAddStatementById(
  addStatementId: string
): Promise<CommonObject> {
  return api.get(`getAddStatementById?id=${addStatementId}`);
}

export function recendSave(payload: PayloadRecendSave): Promise<void> {
  return api.post('save', payload);
}

export function recendStatementXmlBase64(
  addStatementId: string
): Promise<string> {
  return api.get(`statementXmlBase64?statementId=${addStatementId}`);
}

export function recendSendPackage(
  payload: PayloadRecendSendPackage
): Promise<void> {
  return api.post('sendPackage', payload);
}

export function recendSaveDraft(
  payload: CommonObject
): Promise<AddStatementDraftResp> {
  return api.post('saveDraft', payload);
}

export function recendDeleteStatementLink(addStatementId: string) {
  return api.delete(`deleteStatementLink?addStatementId=${addStatementId}`);
}
